<template style="height: 100%;">
    <div style="height: 100%" id="homeBox">

        <!--导入记录-->
        <div  >

                <el-select @change="kqdataChange" style="width: 30%;" size="mini" v-model="kqdata" slot="prepend" placeholder="请选择">
                    <el-option v-for="val in kaoqinList" :key="val.i_id" :label='val.vc_tcname' :value="val.vc_tcname"></el-option>
                </el-select>


        </div>
        <el-table
                class="el-table-width"
                ref="deliverlight"
                :height="tableHeight"
                highlight-current-row
                :data="tableData"
                border>
            <el-table-column
                    prop="forMonth"
                    label="考勤周期"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    {{scope.row.dt_begin+'至'+scope.row.dt_end}}
                </template>
            </el-table-column>
            <el-table-column
                    prop="i_shouldattend"
                    label="应出勤天数"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-input-number :controls="false" v-if="scope.row.edit" :precision="1" :step="0.5" :step-strictly="true" v-model="scope.row.i_shouldattend" :min="1"  style="width:140px">
                    </el-input-number>
                    <span v-else>
                       {{scope.row.i_shouldattend}}

                    </span>
                </template>
            </el-table-column>
            <el-table-column
                    label="操作"
                    show-overflow-tooltip
            width="200px">
                <template slot-scope="scope">
<!--                    <el-button v-if="scope.row.type==3&&scope.row.result!==2&&scope.row.result!==0"  type="text" @click="saveexamine(scope.row,3)">审核</el-button>-->
<!--                    <el-button v-if="scope.row.type==1&&scope.row.result!==2"  type="text" @click="addPunch(scope.row)">补打卡</el-button>-->
<!--                    <el-button v-if="scope.row.type==2&&scope.row.result!==2"  type="text" @click="addSche(scope.row)">补排班</el-button>-->
<!--                    <el-button v-if="scope.row.result==2&&scope.row.type==3"  type="text" @click="saveexamine(scope.row,4)">解冻</el-button>-->
                    <el-button  type="text" @click="chuli(scope.row)">处理</el-button>
                    <el-button  type="text" v-if="!scope.row.edit" @click="edit(scope.row)">编辑</el-button>
                    <el-button  type="text" v-if="scope.row.edit"  @click="save(scope.row)">保存</el-button>

<!--                    <el-button v-if="scope.row.type==3&&scope.row.result!==0" type="text" @click.stop="lookreport(scope.row)">查看明细</el-button>-->
<!--                    <el-button v-if="scope.row.type==3&&scope.row.result!==0" type="text" @click.stop="lookreporttwo(scope.row)">查看合计</el-button>-->

                    <!--                        <span v-if="scope.row.type==3">审核通过</span>-->
                </template>
            </el-table-column>
        </el-table>
        <!--        分页器-->
        <div class="block">
            <div class="pages">
                <div class="choosepage flexother mrt20 fl">
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :page-sizes="[10, 20, 30, 40]"
                            :page-size="this.pageSize"
                            layout="total,sizes"
                            :total="this.total"
                    >
                    </el-pagination>
                    <el-pagination
                            small
                            :pager-count="5"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :page-size="this.pageSize"
                            layout="prev, pager, next, jumper"
                            :total="this.total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <!--排班导入弹框-->
        <el-dialog
                :close-on-click-modal="false"

                style="display: flex;justify-content: center;align-items: center"
                width="39.429rem"
                top="2.143rem"
                height="300"
                title="排班导入"
                :visible.sync="addSchedialog"
                v-if="addSchedialog"
        >
            <sche-dialog :djmark="djmark" :kaoqini_id="kaoqini_id" @saveSche="saveSche" style="display: flex;justify-content: center"  @close="close"> </sche-dialog>
        </el-dialog>

        <!--打卡导入弹框-->
        <el-dialog
                :close-on-click-modal="false"

                style="display: flex;justify-content: center;align-items: center"
                width="39.429rem"
                top="2.143rem"
                height="300"
                title="打卡导入"
                :visible.sync="addPunchdialog"
                v-if="addPunchdialog"
        >
            <punch-import :djmark="djmark" class="displayflex" @savePunch="savePunch"   @close="close"> </punch-import>
        </el-dialog>
        <div class="contentLeft">
            <reportdialog  ref="mydialog"   ></reportdialog>
            <eDialog ref="eDialog" :activePage="activePage"></eDialog>
        </div>
        <!--审批dialog-->
        <div :class="baseerp+'div'">
            <el-dialog

                    class="dia"
                    width="30%"
                    :title="diatitle"
                    :visible.sync="checkdialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-loading="loading"
                    element-loading-text="正在提交中..."
                    v-if="checkdialogVisible">
                <p id="loading1">{{diatext}}</p>
                <div style="text-align: right; margin: 0">
<!--                    <el-button size="mini"   @click="checkdialogVisible = false">取消</el-button>-->
                    <el-button type="primary" :class="baseerp+'btn'" size="mini" @click="wancheng">关闭</el-button>
                </div>
            </el-dialog>
            <el-dialog
                    class="cldialog"
                    style="display: flex;justify-content: center;align-items: center;"
                    width="70%"
                    top="2.143rem"
                    height="300"
                    title="处理"
                    :visible.sync="chuliDialog"
                    v-if="chuliDialog"
            >
                <el-steps direction="vertical" :active="activeId" space="90px">
                    <el-step  icon="el-icon-upload" @click="uploadFile">
                        <div slot="title">
                            <div style="position: relative;display: inline-block" >
                                <input type="file" name="files" value="" id="uploadfile"
                                   ref="uploadclear"    class="upload-input uploadfile1" @change="uploadFile" v-if="activeId==0" >
                                   <el-button  :disabled="activeId!=0">打卡数据导入</el-button>
                            </div>
                            <div style="position: relative;display: inline-block;cursor: pointer;margin-left: 10px"  v-if="activeId>0&&activeId!=5">
                                <input type="file" name="files" value="" id="uploadfile"
                                   ref="uploadclear1" style="cursor: pointer" class="upload-input uploadfile-icon" @change="uploadFile" >
                                    <el-button icon="el-icon-refresh-left" style="cursor: pointer" circle></el-button>

                            </div>
                        </div>
                    </el-step>
                    <el-step title="生成考勤" icon="el-icon-document">
                        <div slot="title">
                            <div style="display: inline-block" >
                                <el-button   @click="attendresult" :disabled="activeId!=1">处理打卡数据</el-button>
                                <div v-if="activeId==2" style="font-size: 14px;" >
                                    ...等待处理补假
                                </div>
                            </div>

<!--                            <el-button v-if="activeId>1" @click="lookreport" style="float: right">查看明细</el-button>-->
<!--                            <el-button v-if="activeId>1" @click.stop="lookreporttwo"  style="float: right">查看合计</el-button> -->


                            <el-button icon="el-icon-refresh-left" style="cursor: pointer;vertical-align: top;margin-left: 10px" circle  @click="attendresult" v-if="activeId>1&&activeId!=5"></el-button>
                            <el-button   style="color: #409eff;vertical-align: top;margin-left: 10px" v-if="i_isfreeze==1&&activeId>=1" @click="freeze(0)" >(解冻排班)</el-button>
                            <el-button   style="color: red;vertical-align: top;margin-left: 10px" @click="freeze(1)" v-if="i_isfreeze==0&&activeId>=1" >(冻结排班)</el-button>


                            <el-button v-if="activeId>1" @click="getExcel(1)"  style="float: right">下载明细</el-button>
                            <el-button v-if="activeId>1" @click="getExcel(2)"  style="float: right">下载合计</el-button>
                        </div>

                    </el-step>
                    <el-step title="生成考勤结果" icon="el-icon-edit" >
                         <div slot="title">
                            <el-button    @click="handleOvertime" :disabled="activeId!=2">生成考勤结果</el-button>
                            <el-button    @click="workovertime" v-if="activeId>2"  style="float: right">查看报表</el-button>
                            <el-button icon="el-icon-refresh-left" style="cursor: pointer;margin-right: 15px" circle @click="handleOvertime" v-if="activeId>2&&activeId!=5"></el-button>
                             <el-button   style="color: red" @click="saveexamine(3)" v-if="activeId==4" :disabled="activeId!==4">(冻结)</el-button>
                             <el-button   v-if="activeId==5" @click="saveexamine(4)" :disabled="activeId!==5">(解冻)</el-button>
                        </div>
                    </el-step>
                </el-steps>
            </el-dialog>
        </div>

    </div>
</template>

<script>
    import * as API from "./api"
    import PunchImport from "./statsinfo/component/PunchImport";
    import ScheDialog from "./statsinfo/component/ScheDialog";
    // import FileDialog from "./component/FileDialog";
    import reportdialog from "@/components/dialog"; // dialog
    import eDialog from "@/components/eDialog"; // dialog
    import{sse_url} from '@/utils/baseUrl';

    import {mapActions} from "vuex";
    import {baseerp,baseApp,baseVersion,file_url} from "@/utils/baseUrl";

    export default {
        name: "absStatist",
        components:{
            // FileDialog,
            eDialog,
            // reportList,
            reportdialog,
            PunchImport,
            ScheDialog
        },
        data(){
            return{
                diatext:'',
                diatitle:'',
                ceshi:1,
                loadmessage:'',
                checkdialogVisible:false,
                activePage:"report/res/spread.vue",
                attendenceDate:'',
                startDate:'',
                endDate:'',
                inputType:'text',
                moreuploadFile:false,
                uploadType:0,
                kqdata:'',
                addSchedialog:false,
                addPunchdialog:false,
                recordsId:0,
                filenewname:'',
                tableData: [],//列表数据
                currentPage:1,//页
                pageSize:10,//条
                total:0,//总数
                baseerp:'',//公共样式
                StatsSearchdata:'',//搜索记录内容
                tableHeight:0,
                djmark:'',//考勤方案
                uploadid:0,//上传文件ID
                kaoqinList:[],
                kaoqini_id:0,
                fileId:0,
                uploadtype:0,
                departmentId:0,
                formonth:'',
                loading:false,
                uuid:0,
                timestamp:'',
                JzNum:0,
                JzTotal:0,
                percentagetable:0,
                sseId:0,
                sureTitle:"",
                ty_pe:"",
                files:'',
                baseApp:'',
                baseVersion:'',
                dialogjudge:0,
                source:'',
                socket:null,
                chuliDialog:false,
                activeId:4,
                i_isfreeze:0,
            }
        },
        watch:{
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
            treedata:{
                handler(){
                    if (this.treedata){
                    }
                },
                immediate:true,
                deep:true
            },



        },
        activated(){
            this.onResize();
        },
        mounted(){
            // this.socket = this.$getSocket('kqfa');
            // this.socket.onmessage=(res)=>{
            //     console.log('****kqfa****'+res.data)
            //
            // }
            // this.socket.onclose=()=>{
            //     console.log('****kqfa****关闭')
            //
            // }
            this.baseVersion=baseVersion
            this.baseerp=baseerp
            this.baseApp=baseApp
            this.file_url=file_url
            this.token=sessionStorage.getItem("token")
            this.i_uid=sessionStorage.getItem("userid")
            // console.log(this.baseVersion)
            this.$nextTick(()=>{
                this.onResize();

            })

            this.uuid=sessionStorage.getItem('uuid');
            this.getKqList()


        },
        beforeDestroy(){
            if (this.socket!=null){
                // console.log('=======')

                this.socket.close()
            }
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-80

                // console.log(n.h)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            edit(row){
                row.edit=true
            },
            save(row){
                row.edit=false
                this.saveInterval(row)
            },
            chuli(row){
                this.chuliDialog=true
                this.chooseRow=row
                this.activeId=this.chooseRow.i_state
                this.i_isfreeze=this.chooseRow.i_isfreeze
                this.attendenceDate=this.chooseRow.vc_formonth;
            },
            async saveInterval(row){
                let params = {
                    i_id:row.i_id,
                    i_shouldattend:row.i_shouldattend,
                };
                let res = await API.saveInterval(params);
                if (res.code == 1) {
                    this.getKqList()
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async getExcel(type){
               let typetxt= type==2?'合计':'明细';
                let notice=this.$notify({
                    title:'下载提示',
                    message:`${this.chooseRow.dt_begin}至${this.chooseRow.dt_end}打卡${typetxt}正在下载中`,
                    duration:0,
                    showClose:false,
                })
                let params = {
                    startDate: this.chooseRow.dt_begin,
                    endDate:this.chooseRow.dt_end,
                    i_type:type,
                    vc_djmark:this.chooseRow.vc_djmark,
                    i_kqtcid:this.kaoqini_id
                };
                let res = await API.getExcel(params);
                if (res.code == 1) {
                    let dload=document.createElement('a'),
                    href=this.file_url+'param='+encodeURI('{app:\''+this.baseApp+'\',i_uid:\''+this.i_uid+'\',token:\''+this.token+'\',version:\''+this.baseVersion+'\',fid:\''+res.data.vc_newname+',attendence\'}','utf-8');
                    dload.download=res.data.vc_name;
                    dload.href= href;
                    document.body.appendChild(dload);
                    dload.click();
                    dload.remove();
                    notice.close();
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                    notice.close();
                } else {
                    notice.close();
                    this.$message.error(res.message);
                }
            },
            async handleOvertime(){
                this.timestamp = (new Date()).valueOf();
                this.diatext='正在生成考勤，请稍候'
                this.diatitle='生成考勤'
                this.sse_fun()
                this.checkdialogVisible=true
                let params = {
                    forMonth:this.attendenceDate,
                    i_kqtcid:this.kaoqini_id,
                    sseId:this.timestamp

                }
                let res = await API.handleOvertime(params);
                if (res.code == 1) {
                    this.checkdialogVisible=false
                    if(this.dialogjudge!==1){
                        this.closeSSE()
                    }
                    // loading.close()
                    this.intervalList()
                    this.activeId=5
                    this.$message({
                        message:res.message,
                        type: 'success'
                    });
                } else if (res.code == -2) {
                    this.checkdialogVisible=false
                    if(this.dialogjudge!==1){
                        this.closeSSE()
                    }

                    // loading.close()
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.checkdialogVisible=false
                    if(this.dialogjudge!==1){
                        this.closeSSE()
                    }

                    // loading.close()
                    this.$message.error(res.message);
                }
            },
            async workovertime() {
                // this.formonth=data.forMonth

                let loading =this.$loading({lock:true,text:"正在加载数据,请稍候...",background:"rgba(0,0,0,0.5)"});
                // this.$refs.eDialog.showDialog({title:"报表",btn:{f:this.btn,l:{a:{title:"a",name:"a1"}}},parm:{type:'AttMonthRpt',mid:this.$route.meta.mid},w:800,h:600});
                document.addEventListener('click',function(e){
                    loading.close()
                })
                // console.log(data)
                // return
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                // console.log(this.i_kqtcid)
                let params = {
                    kqtcId: this.kaoqini_id,
                    date:this.attendenceDate

                }
                let res = await API.time(params);
                if (res.code == 1) {
                    // console.log(res)
                    this.startDate=res.data.monthStartTime
                    this.endDate=res.data.monthEndTime
                    this.$refs.eDialog.showDialog({title:"考勤结果报表",parm:{type:'OvertimeRpt',mid:this.$route.meta.mid,arg:{startTime:this.startDate,endTime:this.endDate.substring(0,10),djmark:this.djmark}},w:1024,h:768});
                    loading.close();
                    // console.log(res)
                } else if (res.code == -2) {
                    this.$refs.mydialog.showDialog({type:"error",text:"报表加载失败!("+res.message+")",info:res.error});

                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$refs.mydialog.showDialog({type:"error",text:"报表加载失败!("+res.message+")",info:res.error});

                    this.$message.error(res.message);
                }
            },

            async nextOvertime(){
                let params = {
                    forMonth:this.attendenceDate,
                    i_kqtcid:this.kaoqini_id,
                    vc_djmark:this.chooseRow.vc_djmark,

                }
                let res = await API.nextOvertime(params);
                if (res.code == 1) {
                    this.tableData=res.data.list
                    this.total=res.data.total
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            wancheng(){
                this.dialogjudge=1
                this.closeSSE()
                this.checkdialogVisible=false

            },
            //关闭SSE接口
            async closeSSE(){
                this.source.close();
                let param={
                    userId:this.timestamp+'',
                };
                let res=await API.closeSSE(param);
                if(res.code==1){
                }else if (res.code == -2) {
                    this.$router.push('/login');
                }
                else{
                }
            },
            sse_fun(){
                let that=this;
                let token=sessionStorage.getItem("token")
                let i_uid=sessionStorage.getItem("userid")
                let app=this.baseApp
                let version=this.baseVersion;
                var MESSAGR_URL=sse_url+"/"+"connect"+"/"+this.timestamp+'/'+token+'/'+i_uid+'/'+app+'?version='+version;
                this.source= new EventSource(MESSAGR_URL);
                this.source.addEventListener('open',function (e) {
                })
                this.source.addEventListener('error',function (e) {
                })
                this.source.addEventListener('message',function (e) {
                        var message=e.data;
                        if(message){
                            document.getElementById('loading1').innerHTML=message

                        }
                })
            },
            c(){
                this.checkdialogVisible=true
                this.loading=true;
            setTimeout(()=>{
                this.loading=false
            },2000)
            },
            cancelDialog(){
                this.dialogjudge=1
                this.checkdialogVisible=false
                this.closeSSE()
            },
            //明细报表
            async lookreport() {
                this.formonth=this.attendenceDate
                let loading =this.$loading({lock:true,text:"正在加载数据,请稍候...",background:"rgba(0,0,0,0.5)"});
                document.addEventListener('click',function(e){
                    loading.close()
                })
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                // console.log(this.i_kqtcid)
                let params = {
                   kqtcId: this.kaoqini_id,
                    date:this.formonth

                }
                let res = await API.time(params);
                if (res.code == 1) {
                    this.startDate=res.data.monthStartTime
                    this.endDate=res.data.monthEndTime
                    this.$refs.eDialog.showDialog({title:"考勤明细结果报表",parm:{type:'AttMonthRpt',mid:this.$route.meta.mid,arg:{startDate:this.startDate,endDate:this.endDate.substring(0,10),djmark:this.djmark}},w:1024,h:768});
                    loading.close();
                    // console.log(res)
                } else if (res.code == -2) {
                    this.$refs.mydialog.showDialog({type:"error",text:"报表加载失败!("+res.message+")",info:res.error});

                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$refs.mydialog.showDialog({type:"error",text:"报表加载失败!("+res.message+")",info:res.error});

                    this.$message.error(res.message);
                }
            },
            //合计报表
            async lookreporttwo() {
                this.formonth=this.attendenceDate
                let loading =this.$loading({lock:true,text:"正在加载数据,请稍候...",background:"rgba(0,0,0,0.5)"});
                document.addEventListener('click',function(e){
                    loading.close()
                })
                let result = await this.getCurrentMenuId({path: this.$route.path});
                console.log(this.$route.path,result)

                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                // console.log(this.i_kqtcid)
                let params = {
                    kqtcId: this.kaoqini_id,
                    date:this.formonth

                }
                console.log(params)
                let res = await API.time(params);
                if (res.code == 1) {
                    this.startDate=res.data.monthStartTime
                    this.endDate=res.data.monthEndTime
                    this.$refs.eDialog.showDialog({title:"考勤合计结果报表",parm:{type:'AttMonthHourRpt',mid:this.$route.meta.mid,arg:{startDate:this.startDate,endDate:this.endDate.substring(0,10),djmark:this.djmark}},w:1024,h:768});
                    loading.close();
                    // console.log(res)
                } else if (res.code == -2) {
                    this.$refs.mydialog.showDialog({type:"error",text:"报表加载失败!("+res.message+")",info:res.error});

                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$refs.mydialog.showDialog({type:"error",text:"报表加载失败!("+res.message+")",info:res.error});

                    this.$message.error(res.message);
                }
            },


            //文件上传1
            async uploadFile(value) {
                // console.log(value)
                // var obj=document.getElementById('uploadFile1')
                // obj.s
                this.dialogjudge=0

                this.uploadtype=1

                let that = this;
                let i = 0;
                let $files = value.target.files[0];
                this.files=$files
                let fileName = $files.name;
                let type = $files.type;
                var list = {
                    "image/jpeg": true,
                    "image/png": true,
                    "image/jpg": true,
                    "image/bmp": true,
                    "application/xls": true,
                    "application/xlxs": true
                };
                let result = list[type];

                if ($files) {
                    that.fileName = $files.name;
                    that.fileType = $files.type;
                    that.fileUrl = window.URL.createObjectURL(value.target.files[0]);
                } else {
                    that.fileName = "";
                    that.fileType = "";
                    that.fileUrl = "";
                }
                if (that.fileName) {
                    var fileId = 'uploadfile' + that.idNum;
                    var param = {
                        // "file": fileId,
                        // "fileName": that.fileName,
                        // "IDtype": "",
                        // "type": 1,
                        "style": "attendence",
                        "files": $files,
                        //"token":sessionStorage.getItem("token"),
                        //"app": "dsmanage",
                        "vc_app": "attendence",
                        "i_appid": 0,
                        // "version": "1.0",
                        // "i_uid": sessionStorage.getItem("userid"),
                        "vc_lruname":  sessionStorage.getItem("userid"),
                        "i_lruid": sessionStorage.getItem("userid"),
                        // "i_mid": this.mid
                    };

                    let FD = new FormData();
                    for (let key in param) {
                        FD.append(key, param[key])
                    }

                    let date=this.attendenceDate.split('-')

                    if(param.files.type!=='application/vnd.ms-excel'){
                        this.$message.error('请选择.xls文件进行上传')
                        document.getElementById('uploadfile').outerHTML = document.getElementById('uploadfile').outerHTML
                        document.getElementById('uploadfile').addEventListener('change', this.uploadFile)
                        // value=''
                        // loading.close()
                        return
                    }else {
                        if(param.files.name.indexOf('打卡')==-1){
                            this.$message.error('请选择打卡文件上传')
                            document.getElementById('uploadfile').outerHTML = document.getElementById('uploadfile').outerHTML
                            document.getElementById('uploadfile').addEventListener('change', this.uploadFile)
                            // value=''
                            // loading.close()
                            return
                        }
                        if(param.files.name.indexOf(date[0])==-1||param.files.name.indexOf(date[1])==-1){
                            this.$message.error('请选择正确的日期上传')
                            document.getElementById('uploadfile').outerHTML = document.getElementById('uploadfile').outerHTML
                            document.getElementById('uploadfile').addEventListener('change', this.uploadFile)
                            // value=''
                            // loading.close()
                            return
                        }
                        this.timestamp = (new Date()).valueOf();

                        this.diatext='正在上传文件，请稍候'
                        this.sse_fun()

                        this.diatitle='解析中'
                        this.checkdialogVisible=true
                        this.upload()


                    let res = await API.uploadFile(param);
                    if (res.code == 1) {
                        this.filenewname=res.data[0].filenewname
                        this.uploadid=res.data[0].i_id
                        document.getElementById('uploadfile').outerHTML = document.getElementById('uploadfile').outerHTML
                        document.getElementById('uploadfile').addEventListener('change', this.uploadFile)
                        this.intervalList()
                        this.activeId=1
                    } else if (res.code == -2) {
                        this.$router.push('/login');
                        // loading.close()
                        // this.checkdialogVisible=false
                        // if(this.dialogjudge!==1){
                        //     this.closeSSE()
                        // }
                        document.getElementById('uploadfile').outerHTML = document.getElementById('uploadfile').outerHTML
                        document.getElementById('uploadfile').addEventListener('change', this.uploadFile)
                        this.$message.error(res.message);
                    } else {
                        // loading.close()
                        // this.checkdialogVisible=false
                        // if(this.dialogjudge!==1){
                        //     this.closeSSE()
                        // }
                        document.getElementById('uploadfile').outerHTML = document.getElementById('uploadfile').outerHTML
                        document.getElementById('uploadfile').addEventListener('change', this.uploadFile)
                        // this.$message.error('文件上传失败');
                    }
                    }
                }
            },
            //接口文件上传
            async upload(){

                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };
                var uploaddata={
                    'version':this.baseVersion,
                    "app":this.baseApp,
                    "token":sessionStorage.getItem("token"),
                    "i_uid": sessionStorage.getItem("userid"),
                    "vc_lruname":  sessionStorage.getItem("userid"),
                    "i_lruid": sessionStorage.getItem("userid"),
                    "i_mid": this.mid,
                    "userId":sessionStorage.getItem("userid"),
                    "userName":sessionStorage.getItem("lruname"),
                    "type":this.uploadtype,
                    "date":this.attendenceDate,
                    "djmark":this.djmark,
                    // fileId:this.uploadid,
                    "kqtcId":this.kaoqini_id,
                    "sseId":this.timestamp,
                }

                var data1 =JSON.stringify(uploaddata)
                var params={
                    "file":this.files,
                    "data":data1
                }
                // console.log(params)
                let FD = new FormData();
                for (let key in params) {
                    FD.append(key, params[key])
                }
                let res=await API.upload(params)
                if(res.code==1){
                    this.checkdialogVisible=false
                    if(this.dialogjudge!==1){
                        this.closeSSE()
                    }
                    // console.log('up1')
                    // loading.close()
                    this.intervalList()
                    this.$message({
                        message: res.message,
                        type: 'success'
                    });
                    // this.tableData.bcdetail=res.data
                } else if (res.code == -2) {
                    // loading.close()
                    this.checkdialogVisible=false
                    if(this.dialogjudge!==1){
                        this.closeSSE()
                    }

                    this.intervalList()

                    this.$router.push('/login')
                    this.$message.error(res.message);
                }else{
                    // loading.close()
                    this.checkdialogVisible=false
                    if(this.dialogjudge!==1){
                        this.closeSSE()
                    }

                    this.intervalList()

                    this.$message.error(res.message);
                };
            },

            //补打卡
            addPunch(val){
                // console.log(this.tableData)
                this.fileId=val.id
                this.addPunchdialog=true
            },
            //补排班
            addSche(val){
                this.fileId=val.id
                this.addSchedialog=true
            },

            //考勤下拉框
            kqdataChange(val){
                // console.log(val)
                this.kqdata=val
                let kqdjmark=this.kaoqinList.filter(item=>{
                    return item.vc_tcname==val
                })
                this.djmark=kqdjmark[0].vc_djmark
                this.kaoqini_id=kqdjmark[0].i_id
                this.currentPage=1
                this.intervalList()
                // this.time()

                // console.log(kqdjmark)
            },
            focusupload(){
                // console.log(999)
            },
            //高度
            heightAuto(){
                this.tableHeight = window.innerHeight -  document.getElementById('body').getBoundingClientRect().top -100
            },

            //分页
            handleSizeChange(val) {
                this.pageSize = val;    //动态改变
                this.intervalList()
            },
            handleCurrentChange(val) {
                this.currentPage = val;    //动态改变
                this.intervalList()

            },
            //关闭弹框
            close(){
                this.addPunchdialog=false
                this.addSchedialog=false
                this.moreuploadFile=false

            },
            //搜索
            StatsSearch(){
                // console.log(this.attendenceDate)
                this.intervalList()
                this.currentPage=1


            },

            //解冻
            async savethaw(data){

                let param={
                    formonth:data.forMonth,
                    type:4
                }
                let res=await API.save(param)
                if(res.code==1){
                    this.$message({
                        message:res.message,
                        type: 'success'
                    });
                    this.intervalList()
                    // this.addSchedialog=false
                    // console.log(res,11)
                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },
            //冻结排班
            async freeze(type){
                // this.i_isfreeze=null
                let param={
                   i_id:this.chooseRow.i_id,
                    i_isfreeze:type,
                }
                let res=await API.freeze(param)
                if(res.code==1){
                    this.$message({
                        message:res.message,
                        type: 'success'
                    });
                    this.intervalList();
                    this.$forceUpdate();
                    this.i_isfreeze=type;
                    this.$forceUpdate();
                    // this.addSchedialog=false
                    // console.log( this.i_isfreeze,type,'type')
                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },
            //审核
            async saveexamine(type){
                let param={
                   formonth:this.attendenceDate,
                    type:type,
                    kqtcId:this.kaoqini_id,
                    djmark:this.djmark,

                }
                let res=await API.save(param)
                if(res.code==1){
                    this.$message({
                        message:res.message,
                        type: 'success'
                    });
                    this.intervalList()
                    if(type==3){
                        this.activeId=5

                    }else if(type==4){
                        this.activeId=4

                    }

                    // this.addSchedialog=false
                    // console.log(res,11)
                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },
            //保存排班
            async saveSche(data){
                // console.log(data)
                // return
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };
                let param={
                    bcId:data.bcId,
                    bcName:data.bcName,
                    bcNote:data.bcNote,
                    creator:sessionStorage.getItem("lruname"),
                    djmark:this.djmark,
                    dkNum:data.dkNum,
                    name:data.name,
                    scheduleDate:data.scheduleDate,
                    theoryHour:data.theoryHour,
                    userId:data.userId,
                    whichHalf:data.whichHalf,
                    workEndTime:data.workEndTime,
                    workStartTime:data.workStartTime,
                    fileId:this.fileId,
                    type:2,
                    dkRange:data.dkRange
                }
                let res=await API.save(param)
                if(res.code==1){
                    this.$message({
                        message:res.message,
                        type: 'success'
                    });
                    this.addSchedialog=false
                    // console.log(res,11)
                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },
            //文件上传2
            async uploadFile2(value) {
                this.dialogjudge=0

                this.uploadtype=2
                // var loading = this.$loading({
                //     lock: true,
                //     text: '上传中',
                //     spinner: 'el-icon-loading',
                //     background: 'rgba(0, 0, 0, 0.7)'
                // });
                // document.addEventListener('click',function(e){
                //     loading.close()
                // })
                // console.log(this.uploadtype)
// return
                // console.log(value)
                // return
                let that = this;
                let i = 0;
                let $files = value.target.files[0];
                this.files=$files
                let fileName = $files.name;
                let type = $files.type;
                var list = {
                    "image/jpeg": true,
                    "image/png": true,
                    "image/jpg": true,
                    "image/bmp": true,
                    "application/pdf": true
                };
                let result = list[type];
                // if(($files && result==false) || ($files &&result==undefined)){
                //     that.$message.error('请上传格式正确的文件');
                //     return;
                // };
                if ($files) {
                    that.fileName = $files.name;
                    that.fileType = $files.type;
                    that.fileUrl = window.URL.createObjectURL(value.target.files[0]);
                } else {
                    that.fileName = "";
                    that.fileType = "";
                    that.fileUrl = "";
                }
                // console.log(value)
                // return
                if (that.fileName) {
                    var fileId = 'uploadfile' + that.idNum;
                    var param = {
                        // "file": fileId,
                        // "fileName": that.fileName,
                        // "IDtype": "",
                        // "type": 1,
                        "style": "attendence",
                        "files": $files,
                        //"token":sessionStorage.getItem("token"),
                        //"app": "dsmanage",
                        "vc_app": "attendence",
                        "i_appid": 0,
                        // "version": "1.0",
                        // "i_uid": sessionStorage.getItem("userid"),
                        "vc_lruname":  sessionStorage.getItem("userid"),
                        "i_lruid": sessionStorage.getItem("userid"),
                        // "i_mid": this.mid
                    };
                    let FD = new FormData();
                    for (let key in param) {
                        FD.append(key, param[key])
                    }
                    let date=this.attendenceDate.split('-')
                    if(param.files.type!=='application/vnd.ms-excel'){
                        this.$message.error('请选择.xls文件进行上传')
                        document.getElementById('uploadfile2').outerHTML = document.getElementById('uploadfile2').outerHTML
                        document.getElementById('uploadfile2').addEventListener('change', this.uploadFile2)
                        // this.$refs.uploadclear2.clearFiles()
                        value=''
                        // loading.close()
                        return
                    }else {
                        if(param.files.name.indexOf('排班')==-1){
                            this.$message.error('请选择排班文件上传')
                            document.getElementById('uploadfile2').outerHTML = document.getElementById('uploadfile2').outerHTML
                            document.getElementById('uploadfile2').addEventListener('change', this.uploadFile2)
                            value=''
                            // loading.close()
                            return
                        }
                        if(param.files.name.indexOf(date[0])==-1||param.files.name.indexOf(date[1])==-1){
                            this.$message.error('请选择正确的日期上传')
                            // this.$refs.uploadclear2.clearFiles()
                            document.getElementById('uploadfile2').outerHTML = document.getElementById('uploadfile2').outerHTML
                            document.getElementById('uploadfile2').addEventListener('change', this.uploadFile2)
                            value=''
                            // loading.close()
                            return
                        }
                        this.timestamp = (new Date()).valueOf();

                        this.diatext='正在上传文件，请稍候'
                        this.sse_fun()
                        this.upload()

                        this.diatitle='解析中'
                        this.checkdialogVisible=true
                        let res = await API.uploadFile(param);
                        if (res.code == 1) {
                            // console.log(1)/
                            this.filenewname=res.data[0].filenewname
                            this.uploadid=res.data[0].i_id
                            // loading.close()

                            document.getElementById('uploadfile2').outerHTML = document.getElementById('uploadfile2').outerHTML
                            document.getElementById('uploadfile2').addEventListener('change', this.uploadFile2)
                            // this.$refs.uploadclear2.clearFiles()

                            // console.log(res)
                        } else if (res.code == -2) {
                            // loading.close()
                            // this.checkdialogVisible=false
                            //
                            // if(this.dialogjudge!==1){
                            //     this.closeSSE()
                            // }
                            document.getElementById('uploadfile2').outerHTML = document.getElementById('uploadfile2').outerHTML
                            document.getElementById('uploadfile2').addEventListener('change', this.uploadFile2)
                            this.$router.push('/login');
                            this.$message.error(res.message);
                        } else {
                            document.getElementById('uploadfile2').outerHTML = document.getElementById('uploadfile2').outerHTML
                            document.getElementById('uploadfile2').addEventListener('change', this.uploadFile2)
                            // loading.close()
                            // this.checkdialogVisible=false
                            // if(this.dialogjudge!==1){
                            //     this.closeSSE()
                            // }
                            // this.$message.error('文件上传失败');

                            // this.$message.error(res.message);
                        }
                    }
                }
            },
            //考勤方案接口
            async getKqList() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                // console.log("result",result)
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param = {
                    i_mid: this.mid,

                };
                let res = await API.getKqList(param);
                if (res.code == 1) {
                    // console.log('zxc')
                    // this.ceshiData[0].children=res.data;
                    this.kaoqinList=res.data
                    // console.log(res.data)
                    this.kqdata=res.data[0].vc_tcname
                    // console.log(this.kqdata)
                    let kqdjmark=this.kaoqinList.filter(item=>{
                        return item.vc_tcname==this.kqdata
                    })
                    this.kaoqini_id=kqdjmark[0].i_id
                    this.djmark=kqdjmark[0].vc_djmark
                    // this.tableData.djmark=this.djmark
                    // console.log(this.kaoqini_id)
                    this.intervalList()
                    // console.log(res.data,'-00000');
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            //生成考勤
            async attendresult() {
                this.timestamp = (new Date()).valueOf();
                this.diatext='正在校验考勤，请稍候'
                this.diatitle='校验考勤'
                this.sse_fun()
                this.checkdialogVisible=true
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param = {
                    date:this.attendenceDate,
                    departId:0,
                    creatorId:sessionStorage.getItem("userid"),
                    creatorName:sessionStorage.getItem("lruname"),
                    kqtcId:this.kaoqini_id,
                    djmark:this.djmark,
                    sseId:this.timestamp
                };

                let res = await API.result(param);
                if (res.code == 1) {
                    this.checkdialogVisible=false
                    if(this.dialogjudge!==1){
                        this.closeSSE()
                    }
                    // loading.close()
                    this.intervalList()
                    this.activeId=2
                    this.$message({
                        message:res.message,
                        type: 'success'
                    });
                } else if (res.code == -2) {
                    this.checkdialogVisible=false
                    if(this.dialogjudge!==1){
                        this.closeSSE()
                    }

                    // loading.close()
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.checkdialogVisible=false
                    if(this.dialogjudge!==1){
                        this.closeSSE()
                    }

                    // loading.close()
                    this.$message.error(res.message);
                }
            },
            //打卡导入保存
            async savePunch(data) {
                // console.log(data)
                // return
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                // console.log(this.i_kqtcid)
                let params = {
                    name:data.name,
                    djmark:this.djmark,
                    department:data.department,
                    clockInTime:data.clockInTime,
                    userId:data.userId,
                    type:1,
                    fileId:this.fileId,

                }
                let res = await API.save(params);
                if (res.code == 1) {
                    this.addPunchdialog=false
                    this.$message({
                        message:res.message,
                        type: 'success'
                    });
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            //分页获取导入记录列表
            async intervalList() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    pageSize:this.pageSize,
                    currentPage: this.currentPage,
                    i_kqtcid:this.kaoqini_id
                }
                let res = await API.intervalList(params);
                // console.log(res,'up2')
                if (res.code == 1) {
                    // console.log(this.i_kqtcid)
                    this.tableData=res.data.list
                    this.total=res.data.total

                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

        }
    }
</script>

<style lang="scss" scoped>
    .dib{
        display: inline-block;
    }
    .ml{

    }
    .uploadfile-icon{
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 100%;
    }
    .uploadfile1{
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 100%;
    }
    .uploadfile2
    {
        top: -3px;
        left: 6px;
        position: absolute;
        opacity: 0;
        width: 100px;
        height: 80px;
    }
    .displayflex{
        /*min-width: 39.286rem;*/
        width: 100%;
        /*height: 2.857rem;*/
        display: flex;
        /*justify-content: space-between;*/
        flex-direction: column;
        align-items: center;
        /*margin: 0 0.857rem;*/
    }
    /deep/{
        .el-table-width{
            /*min-width: 960px;*/
        }
        .el-table--enable-row-transition{
            /*min-width: 64.286rem !important;*/
        }
        .el-button--text{
            padding: 0 !important;
            margin-left: 0 !important;
            margin-right: 10px;
        }
        .el-tabs__content{
            /*height: 90% !important;*/
            overflow: visible !important;
            height:calc(100% - 0.357rem) !important;
        }
        .el-step__icon-inner{
            font-size: 21px !important;
        }
        .el-step .el-button--text{
            color: unset;
        }
        .el-step .el-button{
            color: unset;
            border: 1px solid;
        }
        /*.is-finish{*/
        /*    color: #333;*/
        /*    border: ;*/
        /*}*/
        /*.is-process{*/
        /*    color: #409eff;*/
        /*}*/
    }
    /deep/.is-leaf .cell .el-checkbox__input{
        display: none;
    }
    .m{
        padding-top: 1.429rem;
    }
    .flexother {
        display: flex;
        /*flex-flow: wrap;*/
        justify-content: space-between;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }

    .fr{
        float:right;
    }

    .cl{
        clear: both;
    }
    .input{
        width: 14.286rem;
    }
    /*.mrt20{*/
    /*    margin-top: 1.429rem;*/
    /*}*/
    .mrl20{
        margin-left: 1.429rem;
    }
    .mrb20{
        margin-right: 1.429rem;
    }
    .mrr20{
        margin-right: 1.429rem;
    }

    .chooseheader{
        width:100%;
    }

    .choosepage{
        /*min-width: 41.571rem;*/
        width:90%
    }
    .left{
        width: 17.857rem;
    }
    /deep/{
        .el-dialog{
            min-width: 900px;
        }
        .cldialog .el-dialog{
            min-width: 500px;
            max-width: 900px;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
    }
</style>